module.exports = __webpack_public_path__ + "img/people-27-min.ddcb0234.png";